import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReportRatingsList, ReportRatingsToolbar } from 'views/Reports/Ratings/components';
import { useStyles } from './styles';
import RATINGSReportJSON from 'constants/JSONConstants/ratings-report-table-columns';

export default () => {
  const classes = useStyles();
  const { t } = useTranslation(['tables']);

  const fields = RATINGSReportJSON.map(({ title, field, selected, type }) => ({
    title: t(title),
    field,
    hidden: !selected,
    type,
  }));

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <ReportRatingsToolbar />
        <ReportRatingsList fields={fields} />
      </div>
    </div>
  );
};